export default __webpack_public_path__ + "static/media/model-s.2410d799.png";